import { DatasourceReturnType, ResponseError } from 'models/common/respone.model';
import { PositionGroupLogRequest, PositionGroupLog } from '../schemas/PositionGroupLog.schema';
import { retrievePositionGroupLog } from '../datasource/PositionGroupLog.datasource';

export async function getPositionGroupLog(
    params: PositionGroupLogRequest
): Promise<DatasourceReturnType<ResponseError, PositionGroupLog>> {
    try {
        const data = (await retrievePositionGroupLog(params)).data;
        return [null!, data];
    } catch (error) {
        throw error;
    }
}
